import wd from "../images/wd.jpg";
import mad from "../images/mad.jpg";
import uix from "../images/uix.jpg";
export const courses = [
    {
      id: 1,
      cover: wd,
      title:"Website Development",
      Tech:"FullStack",
      price:"$200 - $350",
      Client:"12 Customer",
      provider:"SecureDev",
    },
    {
      id: 2,
      cover: uix,
      title: "UI UX Designing",
      Tech:"Adobe(all), Figma, Canva",
      price:"$100 - $200",
      Client:"35 Customer",
      provider:"SecureDev",
    },
    {
      id: 3,
      cover: mad,
      title: "Android App Development",
      Tech:"Kolin and Dart",
      price:"$290 - $520",
      Client:"3 Customer",
      provider:"SecureDev",
    },
  ]